import { isWithinInterval } from 'date-fns';

interface Props {
  dateToCompare?: Date | string | null;
  startDate?: Date | string | null;
  endDate?: Date | string | null;
}

/**
 * Determines if one date is between two others.
 * Note: returns `true` if all dates are equal
 @returns boolean
 */
export const dateIsWithinInterval = ({
  dateToCompare,
  startDate,
  endDate,
}: Props) => {
  if (!dateToCompare || !startDate || !endDate) {
    return false;
  }

  return isWithinInterval(new Date(dateToCompare), {
    start: new Date(startDate),
    end: new Date(endDate),
  });
};
